import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-youtube",
  "use": "logo-youtube-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"logo-youtube\">\n  <path fill=\"currentColor\" d=\"M6.73 6.18c-.9 0-1.64.73-1.64 1.64v4.36c0 .9.73 1.64 1.64 1.64h6.54c.9 0 1.64-.74 1.64-1.64V7.82c0-.9-.74-1.64-1.64-1.64H6.73zm0-1.09h6.54c1.5 0 2.73 1.22 2.73 2.73v4.36c0 1.5-1.22 2.73-2.73 2.73H6.73A2.73 2.73 0 014 12.18V7.82c0-1.5 1.22-2.73 2.73-2.73zM8.9 7.82L12.18 10l-3.27 2.18V7.82z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol